import { AuthenticatedTemplate } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useAppContext } from './AppContext';
import { useQuery } from 'react-query';
import useClinicCalendar from './hooks/useClinicCalendar';
import EnableEpicOutlookIntegrationAlert from './components/EnableEpicOutlookIntegrationAlert';
import RoundedContainer from './layouts/RoundedContainer';
import Alert from "./components/Alert";
import LoadingSpinner from './LoadingSpinner';
import { ClinicsEnum } from './common/enums';

export default function SendAvailability(props: RouteComponentProps) {
  const app = useAppContext();

  useEffect(() => {
    document.title = "My Clinic Schedule: Send Availability"
 }, []);

  const [publicURL, setPublicURL] = useState<string | undefined>(undefined);

  const userId = app.user?.localAccountId;

  const { data: userInfo, isLoading, refetch: refetchUserDetails } = useQuery<any>(`user-details?userId=${userId}`, {
    enabled: !!userId,
  })

  const { isOnboarded } = useClinicCalendar(true);

  useEffect(() => {
    if (userInfo?.data && userInfo.data.onyen !== undefined) {
      setPublicURL(`${process.env.REACT_APP_REDIRECT_URI}/${userInfo.data.onyen}?clinic=${ClinicsEnum.HOME}`)
    } else {
      setPublicURL(undefined)
    }
  }, [userInfo])

  async function unsubscribePublicCalendar() {
    await fetch(`${process.env.REACT_APP_API_URL}/onyen-unpublish?token=${userId}`);
    refetchUserDetails();
  }

  function userHasPublicURL() {
    return <div>
      <Alert variant="blue" defaultOpen={true}>
        <span>Here's your public URL: <a href={publicURL} className="dark:tw-text-blue-100 tw-font-bold">{publicURL}</a></span>
      </Alert>
      <button
        className="dark:tw-text-blue-100 tw-text-blue-600 tw-underline hover:tw-text-blue-800 tw-mt-4"
        onClick={unsubscribePublicCalendar}
      > Unsubscribe Public Calendar
      </button>
    </div>
  }

  function userDoesNotHavePublicURL() {
    return <Alert variant="green" defaultOpen={true}>
      <a href={`${process.env.REACT_APP_API_URL}/auth-attempt`} className="tw-underline">Click here to generate your public URL</a>
    </Alert>
  }

  function checkIfUserOnboarded() {
    if (isOnboarded) {
      return publicURL ? userHasPublicURL() : userDoesNotHavePublicURL();      
    }

    return <EnableEpicOutlookIntegrationAlert />;
  }

  return (
    <AuthenticatedTemplate>
      <RoundedContainer title="Share your schedule" subheading="Always up to date with Epic and your personal outlook calendar, this link can be shared with anyone">
        {
          isLoading ? <LoadingSpinner /> : checkIfUserOnboarded()
        }
      </RoundedContainer>
    </AuthenticatedTemplate>
  );
}
